import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../services/app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class CtEvetHayirRadioService {
  constructor(private httpClient: HttpClient) {}
  ctDabEvetHayirDataStore(): Observable<any> {
    const formData = new FormData();
    formData.append('lookupAd', 'GEN_EVETHAYIR');
    return this.httpClient.post(
      `${environment.lookupService}api/GetLookup_Request?jsconfig=eccn%2Cedv`,
      formData
    );
  }
}
